module.exports = function (e) {
  function t(n) {
    if (r[n]) return r[n].exports;
    var a = r[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
  }

  var r = {};
  return t.m = e, t.c = r, t.d = function (e, r, n) {
    t.o(e, r) || Object.defineProperty(e, r, {
      configurable: !1,
      enumerable: !0,
      get: n
    });
  }, t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(r, "a", r), r;
  }, t.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, t.p = "", t(t.s = 23);
}([function (e, t) {
  e.exports = require("babel-runtime/core-js/object/keys");
}, function (e, t) {
  e.exports = require("babel-runtime/helpers/typeof");
}, function (e, t) {
  e.exports = require("babel-runtime/core-js/object/assign");
}, function (e, t) {
  e.exports = require("babel-runtime/helpers/extends");
}, function (e, t) {
  e.exports = require("babel-runtime/regenerator");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e) {
    var t = e.openapi;
    return !!t && (0, x.default)(t, "3");
  }

  function u(e) {
    var t = e.swagger;
    return !!t && (0, x.default)(t, "2");
  }

  function o(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
        a = n.v2OperationIdCompatibilityMode;
    return e && "object" === (void 0 === e ? "undefined" : (0, y.default)(e)) ? (e.operationId || "").replace(/\s/g, "").length ? k(e.operationId) : i(t, r, {
      v2OperationIdCompatibilityMode: a
    }) : null;
  }

  function i(e, t) {
    if ((arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).v2OperationIdCompatibilityMode) {
      var r = (t.toLowerCase() + "_" + e).replace(/[\s!@#$%^&*()_+=[{\]};:<>|.\/?,\\'""-]/g, "_");
      return r = r || e.substring(1) + "_" + t, r.replace(/((_){2,})/g, "_").replace(/^(_)*/g, "").replace(/([_])*$/g, "");
    }

    return "" + P(t) + k(e);
  }

  function s(e, t) {
    return P(t) + "-" + e;
  }

  function l(e, t) {
    return e && e.paths ? c(e, function (e) {
      var r = e.pathName,
          n = e.method,
          a = e.operation;
      if (!a || "object" !== (void 0 === a ? "undefined" : (0, y.default)(a))) return !1;
      var u = a.operationId;
      return [o(a, r, n), s(r, n), u].some(function (e) {
        return e && e === t;
      });
    }) : null;
  }

  function c(e, t) {
    return f(e, t, !0) || null;
  }

  function f(e, t, r) {
    if (!e || "object" !== (void 0 === e ? "undefined" : (0, y.default)(e)) || !e.paths || "object" !== (0, y.default)(e.paths)) return null;
    var n = e.paths;

    for (var a in n) {
      for (var u in n[a]) {
        if ("PARAMETERS" !== u.toUpperCase()) {
          var o = n[a][u];

          if (o && "object" === (void 0 === o ? "undefined" : (0, y.default)(o))) {
            var i = {
              spec: e,
              pathName: a,
              method: u.toUpperCase(),
              operation: o
            },
                s = t(i);
            if (r && s) return i;
          }
        }
      }
    }
  }

  function p(e) {
    var t = e.spec,
        r = t.paths,
        n = {};
    if (!r || t.$$normalized) return e;

    for (var a in r) {
      var u = r[a];

      if ((0, g.default)(u)) {
        var i = u.parameters;

        for (var s in u) {
          (function (e) {
            var r = u[e];
            if (!(0, g.default)(r)) return "continue";
            var s = o(r, a, e);

            if (s) {
              n[s] ? n[s].push(r) : n[s] = [r];
              var l = n[s];
              if (l.length > 1) l.forEach(function (e, t) {
                e.__originalOperationId = e.__originalOperationId || e.operationId, e.operationId = "" + s + (t + 1);
              });else if (void 0 !== r.operationId) {
                var c = l[0];
                c.__originalOperationId = c.__originalOperationId || r.operationId, c.operationId = s;
              }
            }

            if ("parameters" !== e) {
              var f = [],
                  p = {};

              for (var d in t) {
                "produces" !== d && "consumes" !== d && "security" !== d || (p[d] = t[d], f.push(p));
              }

              if (i && (p.parameters = i, f.push(p)), f.length) {
                var v = !0,
                    y = !1,
                    m = void 0;

                try {
                  for (var b, x = (0, h.default)(f); !(v = (b = x.next()).done); v = !0) {
                    var P = b.value;

                    for (var k in P) {
                      if (r[k]) {
                        if ("parameters" === k) {
                          var w = !0,
                              _ = !1,
                              O = void 0;

                          try {
                            for (var q, M = (0, h.default)(P[k]); !(w = (q = M.next()).done); w = !0) {
                              !function () {
                                var e = q.value;
                                r[k].some(function (t) {
                                  return t.name && t.name === e.name || t.$ref && t.$ref === e.$ref || t.$$ref && t.$$ref === e.$$ref || t === e;
                                }) || r[k].push(e);
                              }();
                            }
                          } catch (e) {
                            _ = !0, O = e;
                          } finally {
                            try {
                              !w && M.return && M.return();
                            } finally {
                              if (_) throw O;
                            }
                          }
                        }
                      } else r[k] = P[k];
                    }
                  }
                } catch (e) {
                  y = !0, m = e;
                } finally {
                  try {
                    !v && x.return && x.return();
                  } finally {
                    if (y) throw m;
                  }
                }
              }
            }
          })(s);
        }
      }
    }

    return t.$$normalized = !0, e;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var d = r(18),
      h = n(d),
      v = r(1),
      y = n(v);
  t.isOAS3 = a, t.isSwagger2 = u, t.opId = o, t.idFromPathMethod = i, t.legacyIdFromPathMethod = s, t.getOperationRaw = l, t.findOperation = c, t.eachOperation = f, t.normalizeSwagger = p;

  var m = r(47),
      g = n(m),
      b = r(14),
      x = n(b),
      P = function P(e) {
    return String.prototype.toLowerCase.call(e);
  },
      k = function k(e) {
    return e.replace(/[^\w]/gi, "_");
  };
}, function (e, t) {
  e.exports = require("lodash/assign");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e, t) {
    return "application/json" === t ? JSON.parse(e) : M.default.safeLoad(e);
  }

  function u(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        n = r.loadSpec,
        u = void 0 !== n && n,
        i = {
      ok: e.ok,
      url: e.url || t,
      status: e.status,
      statusText: e.statusText,
      headers: o(e.headers)
    },
        s = i.headers["content-type"],
        l = u || I(s);
    return (l ? e.text : e.blob || e.buffer).call(e).then(function (e) {
      if (i.text = e, i.data = e, l) try {
        var t = a(e, s);
        i.body = t, i.obj = t;
      } catch (e) {
        i.parseError = e;
      }
      return i;
    });
  }

  function o() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = {};
    return "function" == typeof e.forEach ? (e.forEach(function (e, r) {
      void 0 !== t[r] ? (t[r] = Array.isArray(t[r]) ? t[r] : [t[r]], t[r].push(e)) : t[r] = e;
    }), t) : t;
  }

  function i(e, t) {
    return t || "undefined" == typeof navigator || (t = navigator), t && "ReactNative" === t.product ? !(!e || "object" !== (void 0 === e ? "undefined" : (0, P.default)(e)) || "string" != typeof e.uri) : "undefined" != typeof File ? e instanceof File : null !== e && "object" === (void 0 === e ? "undefined" : (0, P.default)(e)) && "function" == typeof e.pipe;
  }

  function s(e, t) {
    var r = e.collectionFormat,
        n = e.allowEmptyValue,
        a = "object" === (void 0 === e ? "undefined" : (0, P.default)(e)) ? e.value : e,
        u = {
      csv: ",",
      ssv: "%20",
      tsv: "%09",
      pipes: "|"
    };
    if (void 0 === a && n) return "";
    if (i(a) || "boolean" == typeof a) return a;
    var o = encodeURIComponent;
    return t && (o = (0, j.default)(a) ? function (e) {
      return e;
    } : function (e) {
      return (0, m.default)(e);
    }), "object" !== (void 0 === a ? "undefined" : (0, P.default)(a)) || Array.isArray(a) ? Array.isArray(a) ? Array.isArray(a) && !r ? a.map(o).join(",") : "multi" === r ? a.map(o) : a.map(o).join(u[r]) : o(a) : "";
  }

  function l(e) {
    var t = (0, v.default)(e).reduce(function (t, r) {
      var n = e[r],
          a = !!n.skipEncoding,
          u = a ? r : encodeURIComponent(r),
          o = function (e) {
        return e && "object" === (void 0 === e ? "undefined" : (0, P.default)(e));
      }(n) && !Array.isArray(n);

      return t[u] = s(o ? n : {
        value: n
      }, a), t;
    }, {});
    return O.default.stringify(t, {
      encode: !1,
      indices: !1
    }) || "";
  }

  function c() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.url,
        n = void 0 === t ? "" : t,
        a = e.query,
        u = e.form;

    if (u) {
      var o = (0, v.default)(u).some(function (e) {
        return i(u[e].value);
      }),
          c = e.headers["content-type"] || e.headers["Content-Type"];

      if (o || /multipart\/form-data/i.test(c)) {
        var f = r(30);
        e.body = new f(), (0, v.default)(u).forEach(function (t) {
          e.body.append(t, s(u[t], !0));
        });
      } else e.body = l(u);

      delete e.form;
    }

    if (a) {
      var p = n.split("?"),
          h = (0, d.default)(p, 2),
          y = h[0],
          m = h[1],
          g = "";

      if (m) {
        var b = O.default.parse(m);
        (0, v.default)(a).forEach(function (e) {
          return delete b[e];
        }), g = O.default.stringify(b, {
          encode: !0
        });
      }

      var x = function () {
        for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        var n = t.filter(function (e) {
          return e;
        }).join("&");
        return n ? "?" + n : "";
      }(g, l(a));

      e.url = y + x, delete e.query;
    }

    return e;
  }

  function f(e, t, r) {
    return r = r || function (e) {
      return e;
    }, t = t || function (e) {
      return e;
    }, function (n) {
      return "string" == typeof n && (n = {
        url: n
      }), C.mergeInQueryOrForm(n), n = t(n), r(e(n));
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.shouldDownloadAsText = t.self = void 0;
  var p = r(26),
      d = n(p),
      h = r(0),
      v = n(h),
      y = r(8),
      m = n(y),
      g = r(4),
      b = n(g),
      x = r(1),
      P = n(x),
      k = r(11),
      w = n(k);
  t.serializeRes = u, t.serializeHeaders = o, t.isFile = i, t.encodeFormOrQuery = l, t.mergeInQueryOrForm = c, t.makeHttp = f, r(27);

  var _ = r(28),
      O = n(_),
      q = r(15),
      M = n(q),
      A = r(29),
      j = n(A),
      C = t.self = {
    serializeRes: u,
    mergeInQueryOrForm: c
  };

  t.default = function () {
    function e(e) {
      return t.apply(this, arguments);
    }

    var t = (0, w.default)(b.default.mark(function e(t) {
      var r,
          n,
          a,
          u,
          o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return b.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if ("object" === (void 0 === t ? "undefined" : (0, P.default)(t)) && (o = t, t = o.url), o.headers = o.headers || {}, C.mergeInQueryOrForm(o), !o.requestInterceptor) {
                e.next = 10;
                break;
              }

              return e.next = 6, o.requestInterceptor(o);

            case 6:
              if (e.t0 = e.sent, e.t0) {
                e.next = 9;
                break;
              }

              e.t0 = o;

            case 9:
              o = e.t0;

            case 10:
              return r = o.headers["content-type"] || o.headers["Content-Type"], /multipart\/form-data/i.test(r) && (delete o.headers["content-type"], delete o.headers["Content-Type"]), n = void 0, e.prev = 13, e.next = 16, (o.userFetch || fetch)(o.url, o);

            case 16:
              return n = e.sent, e.next = 19, C.serializeRes(n, t, o);

            case 19:
              if (n = e.sent, !o.responseInterceptor) {
                e.next = 27;
                break;
              }

              return e.next = 23, o.responseInterceptor(n);

            case 23:
              if (e.t1 = e.sent, e.t1) {
                e.next = 26;
                break;
              }

              e.t1 = n;

            case 26:
              n = e.t1;

            case 27:
              e.next = 37;
              break;

            case 29:
              if (e.prev = 29, e.t2 = e.catch(13), n) {
                e.next = 33;
                break;
              }

              throw e.t2;

            case 33:
              throw a = new Error(n.statusText), a.statusCode = a.status = n.status, a.responseError = e.t2, a;

            case 37:
              if (n.ok) {
                e.next = 42;
                break;
              }

              throw u = new Error(n.statusText), u.statusCode = u.status = n.status, u.response = n, u;

            case 42:
              return e.abrupt("return", n);

            case 43:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[13, 29]]);
    }));
    return e;
  }();

  var I = t.shouldDownloadAsText = function () {
    return /(json|xml|yaml|text)\b/.test(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "");
  };
}, function (e, t) {
  e.exports = require("babel-runtime/core-js/json/stringify");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e, t, r) {
    if (r = r || {}, t = (0, L.default)({}, t, {
      path: t.path && u(t.path)
    }), "merge" === t.op) {
      var n = T(e, t.path);
      (0, L.default)(n, t.value), U.default.applyPatch(e, [i(t.path, n)]);
    } else if ("mergeDeep" === t.op) {
      var a = T(e, t.path);

      for (var o in t.value) {
        var s = t.value[o],
            l = Array.isArray(s);

        if (l) {
          var c = a[o] || [];
          a[o] = c.concat(s);
        } else if (w(s) && !l) {
          var f = (0, L.default)({}, a[o]);

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(f, p)) {
              f = (0, W.default)((0, Y.default)({}, f), s);
              break;
            }

            (0, L.default)(f, (0, B.default)({}, p, s[p]));
          }

          a[o] = f;
        } else a[o] = s;
      }
    } else if ("add" === t.op && "" === t.path && w(t.value)) {
      var d = (0, $.default)(t.value).reduce(function (e, r) {
        return e.push({
          op: "add",
          path: "/" + u(r),
          value: t.value[r]
        }), e;
      }, []);
      U.default.applyPatch(e, d);
    } else if ("replace" === t.op && "" === t.path) {
      var h = t.value;
      r.allowMetaPatches && t.meta && C(t) && (Array.isArray(t.value) || w(t.value)) && (h = (0, L.default)({}, h, t.meta)), e = h;
    } else if (U.default.applyPatch(e, [t]), r.allowMetaPatches && t.meta && C(t) && (Array.isArray(t.value) || w(t.value))) {
      var v = T(e, t.path),
          y = (0, L.default)({}, v, t.meta);
      U.default.applyPatch(e, [i(t.path, y)]);
    }

    return e;
  }

  function u(e) {
    return Array.isArray(e) ? e.length < 1 ? "" : "/" + e.map(function (e) {
      return (e + "").replace(/~/g, "~0").replace(/\//g, "~1");
    }).join("/") : e;
  }

  function o(e, t) {
    return {
      op: "add",
      path: e,
      value: t
    };
  }

  function i(e, t, r) {
    return {
      op: "replace",
      path: e,
      value: t,
      meta: r
    };
  }

  function s(e, t) {
    return {
      op: "remove",
      path: e
    };
  }

  function l(e, t) {
    return {
      type: "mutation",
      op: "merge",
      path: e,
      value: t
    };
  }

  function c(e, t) {
    return {
      type: "mutation",
      op: "mergeDeep",
      path: e,
      value: t
    };
  }

  function f(e, t) {
    return {
      type: "context",
      path: e,
      value: t
    };
  }

  function p(e, t) {
    try {
      return h(e, y, t);
    } catch (e) {
      return e;
    }
  }

  function d(e, t) {
    try {
      return h(e, v, t);
    } catch (e) {
      return e;
    }
  }

  function h(e, t, r) {
    return k(P(e.filter(C).map(function (e) {
      return t(e.value, r, e.path);
    }) || []));
  }

  function v(e, t, r) {
    return r = r || [], Array.isArray(e) ? e.map(function (e, n) {
      return v(e, t, r.concat(n));
    }) : w(e) ? (0, $.default)(e).map(function (n) {
      return v(e[n], t, r.concat(n));
    }) : t(e, r[r.length - 1], r);
  }

  function y(e, t, r) {
    r = r || [];
    var n = [];

    if (r.length > 0) {
      var a = t(e, r[r.length - 1], r);
      a && (n = n.concat(a));
    }

    if (Array.isArray(e)) {
      var u = e.map(function (e, n) {
        return y(e, t, r.concat(n));
      });
      u && (n = n.concat(u));
    } else if (w(e)) {
      var o = (0, $.default)(e).map(function (n) {
        return y(e[n], t, r.concat(n));
      });
      o && (n = n.concat(o));
    }

    return n = P(n);
  }

  function m(e, t) {
    if (!Array.isArray(t)) return !1;

    for (var r = 0, n = t.length; r < n; r++) {
      if (t[r] !== e[r]) return !1;
    }

    return !0;
  }

  function g(e, t) {
    return t.reduce(function (e, t) {
      return void 0 !== t && e ? e[t] : e;
    }, e);
  }

  function b(e) {
    return k(P(x(e)));
  }

  function x(e) {
    return Array.isArray(e) ? e : [e];
  }

  function P(e) {
    var t;
    return (t = []).concat.apply(t, (0, D.default)(e.map(function (e) {
      return Array.isArray(e) ? P(e) : e;
    })));
  }

  function k(e) {
    return e.filter(function (e) {
      return void 0 !== e;
    });
  }

  function w(e) {
    return e && "object" === (void 0 === e ? "undefined" : (0, N.default)(e));
  }

  function _(e) {
    return w(e) && O(e.then);
  }

  function O(e) {
    return e && "function" == typeof e;
  }

  function q(e) {
    return e instanceof Error;
  }

  function M(e) {
    if (E(e)) {
      var t = e.op;
      return "add" === t || "remove" === t || "replace" === t;
    }

    return !1;
  }

  function A(e) {
    return G.default.isGeneratorFunction(e);
  }

  function j(e) {
    return M(e) || E(e) && "mutation" === e.type;
  }

  function C(e) {
    return j(e) && ("add" === e.op || "replace" === e.op || "merge" === e.op || "mergeDeep" === e.op);
  }

  function I(e) {
    return E(e) && "context" === e.type;
  }

  function E(e) {
    return e && "object" === (void 0 === e ? "undefined" : (0, N.default)(e));
  }

  function T(e, t) {
    try {
      return U.default.getValueByPointer(e, t);
    } catch (e) {
      return console.error(e), {};
    }
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var F = r(1),
      N = n(F),
      S = r(34),
      D = n(S),
      R = r(0),
      $ = n(R),
      z = r(35),
      B = n(z),
      H = r(2),
      L = n(H),
      V = r(36),
      U = n(V),
      J = r(4),
      G = n(J),
      Q = r(37),
      W = n(Q),
      K = r(38),
      Y = n(K);
  t.default = {
    add: o,
    replace: i,
    remove: s,
    merge: l,
    mergeDeep: c,
    context: f,
    getIn: g,
    applyPatch: a,
    parentPathMatch: m,
    flatten: P,
    fullyNormalizeArray: b,
    normalizeArray: x,
    isPromise: _,
    forEachNew: p,
    forEachNewPrimitive: d,
    isJsonPatch: M,
    isContextPatch: I,
    isPatch: E,
    isMutation: j,
    isAdditiveMutation: C,
    isGenerator: A,
    isFunction: O,
    isObject: w,
    isError: q
  }, e.exports = t.default;
}, function (e, t) {
  e.exports = require("url");
}, function (e, t) {
  e.exports = require("babel-runtime/helpers/asyncToGenerator");
}, function (e, t) {
  e.exports = require("lodash/get");
}, function (e, t) {
  e.exports = require("btoa");
}, function (e, t) {
  e.exports = require("lodash/startsWith");
}, function (e, t) {
  e.exports = require("@kyleshockey/js-yaml");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.requestInterceptor,
        n = t.responseInterceptor,
        a = e.withCredentials ? "include" : "same-origin";
    return function (t) {
      return e({
        url: t,
        loadSpec: !0,
        requestInterceptor: r,
        responseInterceptor: n,
        headers: {
          Accept: "application/json"
        },
        credentials: a
      }).then(function (e) {
        return e.body;
      });
    };
  }

  function u() {
    d.plugins.refs.clearCache();
  }

  function o(e) {
    function t(e) {
      var t = this;
      k && (d.plugins.refs.docCache[k] = e), d.plugins.refs.fetchJSON = a(P, {
        requestInterceptor: g,
        responseInterceptor: b
      });
      var r = [d.plugins.refs];
      return "function" == typeof m && r.push(d.plugins.parameters), "function" == typeof y && r.push(d.plugins.properties), "strict" !== o && r.push(d.plugins.allOf), (0, h.default)({
        spec: e,
        context: {
          baseDoc: k
        },
        plugins: r,
        allowMetaPatches: l,
        pathDiscriminator: f,
        parameterMacro: m,
        modelPropertyMacro: y
      }).then(x ? function () {
        var e = (0, c.default)(s.default.mark(function e(r) {
          return s.default.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", r);

                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e, t);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }() : v.normalizeSwagger);
    }

    var r = e.fetch,
        n = e.spec,
        u = e.url,
        o = e.mode,
        i = e.allowMetaPatches,
        l = void 0 === i || i,
        f = e.pathDiscriminator,
        y = e.modelPropertyMacro,
        m = e.parameterMacro,
        g = e.requestInterceptor,
        b = e.responseInterceptor,
        x = e.skipNormalization,
        P = e.http,
        k = e.baseDoc;
    return k = k || u, P = r || P || p.default, n ? t(n) : a(P, {
      requestInterceptor: g,
      responseInterceptor: b
    })(k).then(t);
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = r(4),
      s = n(i),
      l = r(11),
      c = n(l);
  t.makeFetchJSON = a, t.clearCache = u, t.default = o;
  var f = r(7),
      p = n(f),
      d = r(31),
      h = n(d),
      v = r(5);
}, function (e, t) {
  e.exports = require("babel-runtime/core-js/promise");
}, function (e, t) {
  e.exports = require("babel-runtime/core-js/get-iterator");
}, function (e, t) {
  e.exports = require("babel-runtime/helpers/classCallCheck");
}, function (e, t) {
  e.exports = require("babel-runtime/helpers/createClass");
}, function (e, t, r) {
  "use strict";

  function n(e, t) {
    function r() {
      Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack;

      for (var e = arguments.length, r = Array(e), n = 0; n < e; n++) {
        r[n] = arguments[n];
      }

      this.message = r[0], t && t.apply(this, r);
    }

    return r.prototype = new Error(), r.prototype.name = e, r.prototype.constructor = r, r;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n, e.exports = t.default;
}, function (e, t, r) {
  "use strict";

  function n(e) {
    var t = e[e.length - 1],
        r = e[e.length - 2],
        n = e.join("/");
    return a.indexOf(t) > -1 && -1 === u.indexOf(r) || o.indexOf(n) > -1 || i.some(function (e) {
      return n.indexOf(e) > -1;
    });
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.isFreelyNamed = n;
  var a = ["properties"],
      u = ["properties"],
      o = ["definitions", "parameters", "responses", "securityDefinitions", "components/schemas", "components/responses", "components/parameters", "components/securitySchemes"],
      i = ["schema/example"];
}, function (e, t, r) {
  e.exports = r(24);
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e) {
    var t = this,
        r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    if ("string" == typeof e ? r.url = e : r = e, !(this instanceof a)) return new a(r);
    (0, l.default)(this, r);
    var n = this.resolve().then(function () {
      return t.disableInterfaces || (0, l.default)(t, a.makeApisTagOperation(t)), t;
    });
    return n.client = this, n;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u = r(3),
      o = n(u),
      i = r(25),
      s = (n(i), r(6)),
      l = n(s),
      c = r(14),
      f = n(c),
      p = r(10),
      d = n(p),
      h = r(7),
      v = n(h),
      y = r(16),
      m = n(y),
      g = r(48),
      b = n(g),
      x = r(49),
      P = r(51),
      k = r(5);
  a.http = v.default, a.makeHttp = h.makeHttp.bind(null, a.http), a.resolve = m.default, a.resolveSubtree = b.default, a.execute = P.execute, a.serializeRes = h.serializeRes, a.serializeHeaders = h.serializeHeaders, a.clearCache = y.clearCache, a.parameterBuilders = P.PARAMETER_BUILDERS, a.makeApisTagOperation = x.makeApisTagOperation, a.buildRequest = P.buildRequest, a.helpers = {
    opId: k.opId
  }, a.prototype = {
    http: v.default,
    execute: function execute(e) {
      return this.applyDefaults(), a.execute((0, o.default)({
        spec: this.spec,
        http: this.http,
        securities: {
          authorized: this.authorizations
        },
        contextUrl: "string" == typeof this.url ? this.url : void 0
      }, e));
    },
    resolve: function resolve() {
      var e = this;
      return a.resolve({
        spec: this.spec,
        url: this.url,
        allowMetaPatches: this.allowMetaPatches,
        requestInterceptor: this.requestInterceptor || null,
        responseInterceptor: this.responseInterceptor || null
      }).then(function (t) {
        return e.originalSpec = e.spec, e.spec = t.spec, e.errors = t.errors, e;
      });
    }
  }, a.prototype.applyDefaults = function () {
    var e = this.spec,
        t = this.url;

    if (t && (0, f.default)(t, "http")) {
      var r = d.default.parse(t);
      e.host || (e.host = r.host), e.schemes || (e.schemes = [r.protocol.replace(":", "")]), e.basePath || (e.basePath = "/");
    }
  }, t.default = a, e.exports = t.default;
}, function (e, t) {
  e.exports = require("lodash/cloneDeep");
}, function (e, t) {
  e.exports = require("babel-runtime/helpers/slicedToArray");
}, function (e, t) {
  e.exports = require("cross-fetch/polyfill");
}, function (e, t) {
  e.exports = require("qs");
}, function (e, t) {
  e.exports = require("lodash/isString");
}, function (e, t) {
  e.exports = require("isomorphic-form-data");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e) {
    return new $(e).dispatch();
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.plugins = t.SpecMap = void 0;

  var u = r(8),
      o = n(u),
      i = r(1),
      s = n(i),
      l = r(17),
      c = n(l),
      f = r(4),
      p = n(f),
      d = r(0),
      h = n(d),
      v = r(18),
      y = n(v),
      m = r(32),
      g = n(m),
      b = r(2),
      x = n(b),
      P = r(19),
      k = n(P),
      w = r(20),
      _ = n(w);

  t.default = a;

  var O = r(33),
      q = n(O),
      M = r(9),
      A = n(M),
      j = r(39),
      C = n(j),
      I = r(43),
      E = n(I),
      T = r(44),
      F = n(T),
      N = r(45),
      S = n(N),
      D = r(46),
      R = n(D),
      $ = function () {
    function e(t) {
      (0, k.default)(this, e), (0, x.default)(this, {
        spec: "",
        debugLevel: "info",
        plugins: [],
        pluginHistory: {},
        errors: [],
        mutations: [],
        promisedPatches: [],
        state: {},
        patches: [],
        context: {},
        contextTree: new R.default(),
        showDebug: !1,
        allPatches: [],
        pluginProp: "specMap",
        libMethods: (0, x.default)((0, g.default)(this), A.default),
        allowMetaPatches: !1
      }, t), this.get = this._get.bind(this), this.getContext = this._getContext.bind(this), this.hasRun = this._hasRun.bind(this), this.wrappedPlugins = this.plugins.map(this.wrapPlugin.bind(this)).filter(A.default.isFunction), this.patches.push(A.default.add([], this.spec)), this.patches.push(A.default.context([], this.context)), this.updatePatches(this.patches);
    }

    return (0, _.default)(e, [{
      key: "debug",
      value: function value(e) {
        if (this.debugLevel === e) {
          for (var t, r = arguments.length, n = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
            n[a - 1] = arguments[a];
          }

          (t = console).log.apply(t, n);
        }
      }
    }, {
      key: "verbose",
      value: function value(e) {
        if ("verbose" === this.debugLevel) {
          for (var t, r = arguments.length, n = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
            n[a - 1] = arguments[a];
          }

          (t = console).log.apply(t, ["[" + e + "]   "].concat(n));
        }
      }
    }, {
      key: "wrapPlugin",
      value: function value(e, t) {
        var r = this.pathDiscriminator,
            n = null,
            a = void 0;
        return e[this.pluginProp] ? (n = e, a = e[this.pluginProp]) : A.default.isFunction(e) ? a = e : A.default.isObject(e) && (a = function (e) {
          var t = function t(e, _t) {
            return !Array.isArray(e) || e.every(function (e, r) {
              return e === _t[r];
            });
          };

          return p.default.mark(function n(a, u) {
            var o, i, s, l, c, f, d, v, m;
            return p.default.wrap(function (n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    m = function n(a, s, l) {
                      var c, f, d, v, m, g, b, x, P, k, w, _, O, q, M, j;

                      return p.default.wrap(function (o) {
                        for (;;) {
                          switch (o.prev = o.next) {
                            case 0:
                              if (A.default.isObject(a)) {
                                o.next = 6;
                                break;
                              }

                              if (e.key !== s[s.length - 1]) {
                                o.next = 4;
                                break;
                              }

                              return o.next = 4, e.plugin(a, e.key, s, u);

                            case 4:
                              o.next = 48;
                              break;

                            case 6:
                              c = s.length - 1, f = s[c], d = s.indexOf("properties"), v = "properties" === f && c === d, m = u.allowMetaPatches && i[a.$$ref], g = !0, b = !1, x = void 0, o.prev = 14, P = (0, y.default)((0, h.default)(a));

                            case 16:
                              if (g = (k = P.next()).done) {
                                o.next = 34;
                                break;
                              }

                              if (w = k.value, _ = a[w], O = s.concat(w), q = A.default.isObject(_), M = a.$$ref, m) {
                                o.next = 26;
                                break;
                              }

                              if (!q) {
                                o.next = 26;
                                break;
                              }

                              return u.allowMetaPatches && M && (i[M] = !0), o.delegateYield(n(_, O, l), "t0", 26);

                            case 26:
                              if (v || w !== e.key) {
                                o.next = 31;
                                break;
                              }

                              if (j = t(r, s), r && !j) {
                                o.next = 31;
                                break;
                              }

                              return o.next = 31, e.plugin(_, w, O, u, l);

                            case 31:
                              g = !0, o.next = 16;
                              break;

                            case 34:
                              o.next = 40;
                              break;

                            case 36:
                              o.prev = 36, o.t1 = o.catch(14), b = !0, x = o.t1;

                            case 40:
                              o.prev = 40, o.prev = 41, !g && P.return && P.return();

                            case 43:
                              if (o.prev = 43, !b) {
                                o.next = 46;
                                break;
                              }

                              throw x;

                            case 46:
                              return o.finish(43);

                            case 47:
                              return o.finish(40);

                            case 48:
                            case "end":
                              return o.stop();
                          }
                        }
                      }, o, this, [[14, 36, 40, 48], [41,, 43, 47]]);
                    }, o = p.default.mark(m), i = {}, s = !0, l = !1, c = void 0, n.prev = 6, f = (0, y.default)(a.filter(A.default.isAdditiveMutation));

                  case 8:
                    if (s = (d = f.next()).done) {
                      n.next = 14;
                      break;
                    }

                    return v = d.value, n.delegateYield(m(v.value, v.path, v), "t0", 11);

                  case 11:
                    s = !0, n.next = 8;
                    break;

                  case 14:
                    n.next = 20;
                    break;

                  case 16:
                    n.prev = 16, n.t1 = n.catch(6), l = !0, c = n.t1;

                  case 20:
                    n.prev = 20, n.prev = 21, !s && f.return && f.return();

                  case 23:
                    if (n.prev = 23, !l) {
                      n.next = 26;
                      break;
                    }

                    throw c;

                  case 26:
                    return n.finish(23);

                  case 27:
                    return n.finish(20);

                  case 28:
                  case "end":
                    return n.stop();
                }
              }
            }, n, this, [[6, 16, 20, 28], [21,, 23, 27]]);
          });
        }(e)), (0, x.default)(a.bind(n), {
          pluginName: e.name || t,
          isGenerator: A.default.isGenerator(a)
        });
      }
    }, {
      key: "nextPlugin",
      value: function value() {
        var e = this;
        return (0, q.default)(this.wrappedPlugins, function (t) {
          return e.getMutationsForPlugin(t).length > 0;
        });
      }
    }, {
      key: "nextPromisedPatch",
      value: function value() {
        if (this.promisedPatches.length > 0) return c.default.race(this.promisedPatches.map(function (e) {
          return e.value;
        }));
      }
    }, {
      key: "getPluginHistory",
      value: function value(e) {
        var t = this.getPluginName(e);
        return this.pluginHistory[t] || [];
      }
    }, {
      key: "getPluginRunCount",
      value: function value(e) {
        return this.getPluginHistory(e).length;
      }
    }, {
      key: "getPluginHistoryTip",
      value: function value(e) {
        var t = this.getPluginHistory(e);
        return t && t[t.length - 1] || {};
      }
    }, {
      key: "getPluginMutationIndex",
      value: function value(e) {
        var t = this.getPluginHistoryTip(e).mutationIndex;
        return "number" != typeof t ? -1 : t;
      }
    }, {
      key: "getPluginName",
      value: function value(e) {
        return e.pluginName;
      }
    }, {
      key: "updatePluginHistory",
      value: function value(e, t) {
        var r = this.getPluginName(e);
        (this.pluginHistory[r] = this.pluginHistory[r] || []).push(t);
      }
    }, {
      key: "updatePatches",
      value: function value(e, t) {
        var r = this;
        A.default.normalizeArray(e).forEach(function (e) {
          if (e instanceof Error) return void r.errors.push(e);

          try {
            if (!A.default.isObject(e)) return void r.debug("updatePatches", "Got a non-object patch", e);
            if (r.showDebug && r.allPatches.push(e), A.default.isPromise(e.value)) return r.promisedPatches.push(e), void r.promisedPatchThen(e);
            if (A.default.isContextPatch(e)) return void r.setContext(e.path, e.value);
            if (A.default.isMutation(e)) return void r.updateMutations(e);
          } catch (e) {
            console.error(e), r.errors.push(e);
          }
        });
      }
    }, {
      key: "updateMutations",
      value: function value(e) {
        "object" === (0, s.default)(e.value) && !Array.isArray(e.value) && this.allowMetaPatches && (e.value = (0, x.default)({}, e.value));
        var t = A.default.applyPatch(this.state, e, {
          allowMetaPatches: this.allowMetaPatches
        });
        t && (this.mutations.push(e), this.state = t);
      }
    }, {
      key: "removePromisedPatch",
      value: function value(e) {
        var t = this.promisedPatches.indexOf(e);
        if (t < 0) return void this.debug("Tried to remove a promisedPatch that isn't there!");
        this.promisedPatches.splice(t, 1);
      }
    }, {
      key: "promisedPatchThen",
      value: function value(e) {
        var t = this;
        return e.value = e.value.then(function (r) {
          var n = (0, x.default)({}, e, {
            value: r
          });
          t.removePromisedPatch(e), t.updatePatches(n);
        }).catch(function (r) {
          t.removePromisedPatch(e), t.updatePatches(r);
        });
      }
    }, {
      key: "getMutations",
      value: function value(e, t) {
        return e = e || 0, "number" != typeof t && (t = this.mutations.length), this.mutations.slice(e, t);
      }
    }, {
      key: "getCurrentMutations",
      value: function value() {
        return this.getMutationsForPlugin(this.getCurrentPlugin());
      }
    }, {
      key: "getMutationsForPlugin",
      value: function value(e) {
        var t = this.getPluginMutationIndex(e);
        return this.getMutations(t + 1);
      }
    }, {
      key: "getCurrentPlugin",
      value: function value() {
        return this.currentPlugin;
      }
    }, {
      key: "getPatchesOfType",
      value: function value(e, t) {
        return e.filter(t);
      }
    }, {
      key: "getLib",
      value: function value() {
        return this.libMethods;
      }
    }, {
      key: "_get",
      value: function value(e) {
        return A.default.getIn(this.state, e);
      }
    }, {
      key: "_getContext",
      value: function value(e) {
        return this.contextTree.get(e);
      }
    }, {
      key: "setContext",
      value: function value(e, t) {
        return this.contextTree.set(e, t);
      }
    }, {
      key: "_hasRun",
      value: function value(e) {
        return this.getPluginRunCount(this.getCurrentPlugin()) > (e || 0);
      }
    }, {
      key: "_clone",
      value: function value(e) {
        return JSON.parse((0, o.default)(e));
      }
    }, {
      key: "dispatch",
      value: function value() {
        function e(e) {
          e && (e = A.default.fullyNormalizeArray(e), r.updatePatches(e, n));
        }

        var t = this,
            r = this,
            n = this.nextPlugin();

        if (!n) {
          var a = this.nextPromisedPatch();
          if (a) return a.then(function () {
            return t.dispatch();
          }).catch(function () {
            return t.dispatch();
          });
          var u = {
            spec: this.state,
            errors: this.errors
          };
          return this.showDebug && (u.patches = this.allPatches), c.default.resolve(u);
        }

        if (r.pluginCount = r.pluginCount || {}, r.pluginCount[n] = (r.pluginCount[n] || 0) + 1, r.pluginCount[n] > 100) return c.default.resolve({
          spec: r.state,
          errors: r.errors.concat(new Error("We've reached a hard limit of 100 plugin runs"))
        });

        if (n !== this.currentPlugin && this.promisedPatches.length) {
          var o = this.promisedPatches.map(function (e) {
            return e.value;
          });
          return c.default.all(o.map(function (e) {
            return e.then(Function, Function);
          })).then(function () {
            return t.dispatch();
          });
        }

        return function () {
          r.currentPlugin = n;
          var t = r.getCurrentMutations(),
              a = r.mutations.length - 1;

          try {
            if (n.isGenerator) {
              var u = !0,
                  o = !1,
                  i = void 0;

              try {
                for (var s, l = (0, y.default)(n(t, r.getLib())); !(u = (s = l.next()).done); u = !0) {
                  e(s.value);
                }
              } catch (e) {
                o = !0, i = e;
              } finally {
                try {
                  !u && l.return && l.return();
                } finally {
                  if (o) throw i;
                }
              }
            } else {
              e(n(t, r.getLib()));
            }
          } catch (t) {
            console.error(t), e([(0, x.default)((0, g.default)(t), {
              plugin: n
            })]);
          } finally {
            r.updatePluginHistory(n, {
              mutationIndex: a
            });
          }

          return r.dispatch();
        }();
      }
    }]), e;
  }(),
      z = {
    refs: C.default,
    allOf: E.default,
    parameters: F.default,
    properties: S.default
  };

  t.SpecMap = $, t.plugins = z;
}, function (e, t) {
  e.exports = require("babel-runtime/core-js/object/create");
}, function (e, t) {
  e.exports = require("lodash/find");
}, function (e, t) {
  e.exports = require("babel-runtime/helpers/toConsumableArray");
}, function (e, t) {
  e.exports = require("babel-runtime/helpers/defineProperty");
}, function (e, t) {
  e.exports = require("fast-json-patch");
}, function (e, t) {
  e.exports = require("deep-extend");
}, function (e, t) {
  e.exports = require("@kyleshockey/object-assign-deep");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e, t) {
    if (!B.test(e)) {
      if (!t) throw new H("Tried to resolve a relative URL, without having a basePath. path: '" + e + "' basePath: '" + t + "'");
      return N.default.resolve(t, e);
    }

    return e;
  }

  function u(e, t) {
    var r = void 0;
    return r = e && e.response && e.response.body ? e.response.body.code + " " + e.response.body.message : e.message, new H("Could not resolve reference: " + r, t, e);
  }

  function o(e) {
    return (e + "").split("#");
  }

  function i(e, t) {
    var r = L[e];
    if (r && !D.default.isPromise(r)) try {
      var n = f(t, r);
      return (0, A.default)(_.default.resolve(n), {
        __value: n
      });
    } catch (e) {
      return _.default.reject(e);
    }
    return l(e).then(function (e) {
      return f(t, e);
    });
  }

  function s(e) {
    void 0 !== e ? delete L[e] : (0, k.default)(L).forEach(function (e) {
      delete L[e];
    });
  }

  function l(e) {
    var t = L[e];
    return t ? D.default.isPromise(t) ? t : _.default.resolve(t) : (L[e] = J.fetchJSON(e).then(function (t) {
      return L[e] = t, t;
    }), L[e]);
  }

  function c(e) {
    return (0, j.fetch)(e, {
      headers: {
        Accept: "application/json, application/yaml"
      },
      loadSpec: !0
    }).then(function (e) {
      return e.text();
    }).then(function (e) {
      return I.default.safeLoad(e);
    });
  }

  function f(e, t) {
    var r = p(e);
    if (r.length < 1) return t;
    var n = D.default.getIn(t, r);
    if (void 0 === n) throw new H("Could not resolve pointer: " + e + " does not exist in document", {
      pointer: e
    });
    return n;
  }

  function p(e) {
    if ("string" != typeof e) throw new TypeError("Expected a string, got a " + (void 0 === e ? "undefined" : (0, x.default)(e)));
    return "/" === e[0] && (e = e.substr(1)), "" === e ? [] : e.split("/").map(d);
  }

  function d(e) {
    return "string" != typeof e ? e : T.default.unescape(e.replace(/~1/g, "/").replace(/~0/g, "~"));
  }

  function h(e) {
    return T.default.escape(e.replace(/~/g, "~0").replace(/\//g, "~1"));
  }

  function v(e) {
    return 0 === e.length ? "" : "/" + e.map(h).join("/");
  }

  function y(e, t) {
    if (G(t)) return !0;
    var r = e.charAt(t.length),
        n = t.slice(-1);
    return 0 === e.indexOf(t) && (!r || "/" === r || "#" === r) && "#" !== n;
  }

  function m(e, t, r, n) {
    var a = V.get(n);
    a || (a = {}, V.set(n, a));
    var u = v(r),
        o = (t || "<specmap-base>") + "#" + e;
    if (t == n.contextTree.get([]).baseDoc && y(u, e)) return !0;
    var i = "";
    if (r.some(function (e) {
      return i = i + "/" + h(e), a[i] && a[i].some(function (e) {
        return y(e, o) || y(o, e);
      });
    })) return !0;
    a[u] = (a[u] || []).concat(o);
  }

  function g(e, t) {
    function r(e) {
      return D.default.isObject(e) && (n.indexOf(e) >= 0 || (0, k.default)(e).some(function (t) {
        return r(e[t]);
      }));
    }

    var n = [e];
    return t.path.reduce(function (e, t) {
      return n.push(e[t]), e[t];
    }, e), r(t.value);
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var b = r(1),
      x = n(b),
      P = r(0),
      k = n(P),
      w = r(17),
      _ = n(w),
      O = r(40),
      q = n(O),
      M = r(2),
      A = n(M),
      j = r(41),
      C = r(15),
      I = n(C),
      E = r(42),
      T = n(E),
      F = r(10),
      N = n(F),
      S = r(9),
      D = n(S),
      R = r(21),
      $ = n(R),
      z = r(22),
      B = new RegExp("^([a-z]+://|//)", "i"),
      H = (0, $.default)("JSONRefError", function (e, t, r) {
    this.originalError = r, (0, A.default)(this, t || {});
  }),
      L = {},
      V = new q.default(),
      U = {
    key: "$ref",
    plugin: function plugin(e, t, r, n) {
      var s = r.slice(0, -1);

      if (!(0, z.isFreelyNamed)(s)) {
        var l = n.getContext(r).baseDoc;
        if ("string" != typeof e) return new H("$ref: must be a string (JSON-Ref)", {
          $ref: e,
          baseDoc: l,
          fullPath: r
        });
        var c = o(e),
            f = c[0],
            d = c[1] || "",
            h = void 0;

        try {
          h = l || f ? a(f, l) : null;
        } catch (t) {
          return u(t, {
            pointer: d,
            $ref: e,
            basePath: h,
            fullPath: r
          });
        }

        var v = void 0,
            y = void 0;

        if (!m(d, h, s, n)) {
          if (null == h ? (y = p(d), void 0 === (v = n.get(y)) && (v = new H("Could not resolve reference: " + e, {
            pointer: d,
            $ref: e,
            baseDoc: l,
            fullPath: r
          }))) : (v = i(h, d), v = null != v.__value ? v.__value : v.catch(function (t) {
            throw u(t, {
              pointer: d,
              $ref: e,
              baseDoc: l,
              fullPath: r
            });
          })), v instanceof Error) return [D.default.remove(r), v];
          var b = D.default.replace(s, v, {
            $$ref: e
          });
          if (h && h !== l) return [b, D.default.context(s, {
            baseDoc: h
          })];

          try {
            if (!g(n.state, b)) return b;
          } catch (e) {
            return null;
          }
        }
      }
    }
  },
      J = (0, A.default)(U, {
    docCache: L,
    absoluteify: a,
    clearCache: s,
    JSONRefError: H,
    wrapError: u,
    getDoc: l,
    split: o,
    extractFromDoc: i,
    fetchJSON: c,
    extract: f,
    jsonPointerToArray: p,
    unescapeJsonPointerToken: d
  });

  t.default = J;

  var G = function G(e) {
    return !e || "/" === e || "#" === e;
  };

  e.exports = t.default;
}, function (e, t) {
  e.exports = require("babel-runtime/core-js/weak-map");
}, function (e, t) {
  e.exports = require("cross-fetch");
}, function (e, t) {
  e.exports = require("querystring-browser");
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = r(2),
      a = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(n),
      u = r(22);

  t.default = {
    key: "allOf",
    plugin: function plugin(e, t, r, n, o) {
      if (!o.meta || !o.meta.$$ref) {
        var i = r.slice(0, -1);

        if (!(0, u.isFreelyNamed)(i)) {
          if (!Array.isArray(e)) {
            var s = new TypeError("allOf must be an array");
            return s.fullPath = r, s;
          }

          var l = !1,
              c = o.value;
          i.forEach(function (e) {
            c && (c = c[e]);
          }), c = (0, a.default)({}, c), delete c.allOf;
          var f = [n.replace(i, {})].concat(e.map(function (e, t) {
            if (!n.isObject(e)) {
              if (l) return null;
              l = !0;
              var a = new TypeError("Elements in allOf must be objects");
              return a.fullPath = r, a;
            }

            return n.mergeDeep(i, e);
          }));
          return f.push(n.mergeDeep(i, c)), c.$$ref || f.push(n.remove([].concat(i, "$$ref"))), f;
        }
      }
    }
  }, e.exports = t.default;
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = r(2),
      u = n(a),
      o = r(9),
      i = n(o);
  t.default = {
    key: "parameters",
    plugin: function plugin(e, t, r, n, a) {
      if (Array.isArray(e) && e.length) {
        var o = (0, u.default)([], e),
            s = r.slice(0, -1),
            l = (0, u.default)({}, i.default.getIn(n.spec, s));
        return e.forEach(function (e, t) {
          try {
            o[t].default = n.parameterMacro(l, e);
          } catch (e) {
            var a = new Error(e);
            return a.fullPath = r, a;
          }
        }), i.default.replace(r, o);
      }

      return i.default.replace(r, e);
    }
  }, e.exports = t.default;
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = r(2),
      u = n(a),
      o = r(9),
      i = n(o);
  t.default = {
    key: "properties",
    plugin: function plugin(e, t, r, n) {
      var a = (0, u.default)({}, e);

      for (var o in e) {
        try {
          a[o].default = n.modelPropertyMacro(a[o]);
        } catch (e) {
          var s = new Error(e);
          return s.fullPath = r, s;
        }
      }

      return i.default.replace(r, a);
    }
  }, e.exports = t.default;
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e, t) {
    return u({
      children: {}
    }, e, t);
  }

  function u(e, t, r) {
    return e.value = t || {}, e.protoValue = r ? (0, l.default)({}, r.protoValue, e.value) : e.value, (0, i.default)(e.children).forEach(function (t) {
      var r = e.children[t];
      e.children[t] = u(r, r.value, e);
    }), e;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = r(0),
      i = n(o),
      s = r(3),
      l = n(s),
      c = r(19),
      f = n(c),
      p = r(20),
      d = n(p),
      h = function () {
    function e(t) {
      (0, f.default)(this, e), this.root = a(t || {});
    }

    return (0, d.default)(e, [{
      key: "set",
      value: function value(e, t) {
        var r = this.getParent(e, !0);
        if (!r) return void u(this.root, t, null);
        var n = e[e.length - 1],
            o = r.children;
        if (o[n]) return void u(o[n], t, r);
        o[n] = a(t, r);
      }
    }, {
      key: "get",
      value: function value(e) {
        if (e = e || [], e.length < 1) return this.root.value;

        for (var t = this.root, r = void 0, n = void 0, a = 0; a < e.length && (n = e[a], r = t.children, r[n]); a++) {
          t = r[n];
        }

        return t && t.protoValue;
      }
    }, {
      key: "getParent",
      value: function value(e, t) {
        return !e || e.length < 1 ? null : e.length < 2 ? this.root : e.slice(0, -1).reduce(function (e, r) {
          if (!e) return e;
          var n = e.children;
          return !n[r] && t && (n[r] = a(null, e)), n[r];
        }, this.root);
      }
    }]), e;
  }();

  t.default = h, e.exports = t.default;
}, function (e, t) {
  e.exports = require("lodash/isObject");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = r(4),
      u = n(a),
      o = r(3),
      i = n(o),
      s = r(11),
      l = n(s),
      c = r(12),
      f = n(c),
      p = r(16),
      d = n(p),
      h = r(5);
  t.default = function () {
    function e(e, r) {
      return t.apply(this, arguments);
    }

    var t = (0, l.default)(u.default.mark(function e(t, r) {
      var n,
          a,
          o,
          s,
          l,
          c,
          p,
          v,
          y,
          m,
          g = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return u.default.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n = g.returnEntireTree, a = g.baseDoc, o = g.requestInterceptor, s = g.responseInterceptor, l = g.parameterMacro, c = g.modelPropertyMacro, p = {
                pathDiscriminator: r,
                baseDoc: a,
                requestInterceptor: o,
                responseInterceptor: s,
                parameterMacro: l,
                modelPropertyMacro: c
              }, v = (0, h.normalizeSwagger)({
                spec: t
              }), y = v.spec, e.next = 5, (0, d.default)((0, i.default)({}, p, {
                spec: y,
                allowMetaPatches: !0,
                skipNormalization: !0
              }));

            case 5:
              return m = e.sent, !n && Array.isArray(r) && r.length && (m.spec = (0, f.default)(m.spec, r) || null), e.abrupt("return", m);

            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }));
    return e;
  }(), e.exports = t.default;
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return function (t) {
      var r = t.pathName,
          n = t.method,
          a = t.operationId;
      return function (t) {
        var u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return e.execute((0, l.default)({
          spec: e.spec
        }, (0, f.default)(e, "requestInterceptor", "responseInterceptor", "userFetch"), {
          pathName: r,
          method: n,
          parameters: t,
          operationId: a
        }, u));
      };
    };
  }

  function u() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = v.makeExecute(e),
        r = v.mapTagOperations({
      v2OperationIdCompatibilityMode: e.v2OperationIdCompatibilityMode,
      spec: e.spec,
      cb: t
    }),
        n = {};

    for (var a in r) {
      n[a] = {
        operations: {}
      };

      for (var u in r[a]) {
        n[a].operations[u] = {
          execute: r[a][u]
        };
      }
    }

    return {
      apis: n
    };
  }

  function o() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = v.makeExecute(e);
    return {
      apis: v.mapTagOperations({
        v2OperationIdCompatibilityMode: e.v2OperationIdCompatibilityMode,
        spec: e.spec,
        cb: t
      })
    };
  }

  function i(e) {
    var t = e.spec,
        r = e.cb,
        n = void 0 === r ? d : r,
        a = e.defaultTag,
        u = void 0 === a ? "default" : a,
        o = e.v2OperationIdCompatibilityMode,
        i = {},
        s = {};
    return (0, p.eachOperation)(t, function (e) {
      var r = e.pathName,
          a = e.method,
          l = e.operation;
      (l.tags ? h(l.tags) : [u]).forEach(function (e) {
        if ("string" == typeof e) {
          var u = s[e] = s[e] || {},
              c = (0, p.opId)(l, r, a, {
            v2OperationIdCompatibilityMode: o
          }),
              f = n({
            spec: t,
            pathName: r,
            method: a,
            operation: l,
            operationId: c
          });
          if (i[c]) i[c]++, u["" + c + i[c]] = f;else if (void 0 !== u[c]) {
            var d = i[c] || 1;
            i[c] = d + 1, u["" + c + i[c]] = f;
            var h = u[c];
            delete u[c], u["" + c + d] = h;
          } else u[c] = f;
        }
      });
    }), s;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.self = void 0;
  var s = r(3),
      l = n(s);
  t.makeExecute = a, t.makeApisTagOperationsOperationExecute = u, t.makeApisTagOperation = o, t.mapTagOperations = i;

  var c = r(50),
      f = n(c),
      p = r(5),
      d = function d() {
    return null;
  },
      h = function h(e) {
    return Array.isArray(e) ? e : [e];
  },
      v = t.self = {
    mapTagOperations: i,
    makeExecute: a
  };
}, function (e, t) {
  e.exports = require("lodash/pick");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e) {
    var t = e.http,
        r = e.fetch,
        n = e.spec,
        a = e.operationId,
        u = e.pathName,
        o = e.method,
        i = e.parameters,
        s = e.securities,
        l = (0, y.default)(e, ["http", "fetch", "spec", "operationId", "pathName", "method", "parameters", "securities"]),
        c = t || r || F.default;
    u && o && !a && (a = (0, U.legacyIdFromPathMethod)(u, o));
    var f = K.buildRequest((0, h.default)({
      spec: n,
      operationId: a,
      parameters: i,
      securities: s,
      http: c
    }, l));
    return f.body && ((0, O.default)(f.body) || (0, M.default)(f.body)) && (f.body = (0, p.default)(f.body)), c(f);
  }

  function u(e) {
    var t = e.spec,
        r = e.operationId,
        n = (e.securities, e.requestContentType, e.responseContentType),
        a = e.scheme,
        u = e.requestInterceptor,
        i = e.responseInterceptor,
        s = e.contextUrl,
        l = e.userFetch,
        c = (e.requestBody, e.server),
        f = e.serverVariables,
        p = e.http,
        d = e.parameters,
        v = e.parameterBuilders,
        y = (0, U.isOAS3)(t);
    v || (v = y ? z.default : R.default);
    var m = p && p.withCredentials ? "include" : "same-origin",
        b = {
      url: "",
      credentials: m,
      headers: {},
      cookies: {}
    };
    u && (b.requestInterceptor = u), i && (b.responseInterceptor = i), l && (b.userFetch = l);
    var x = (0, U.getOperationRaw)(t, r);
    if (!x) throw new G("Operation " + r + " not found");
    var P = x.operation,
        k = void 0 === P ? {} : P,
        w = x.method,
        _ = x.pathName;
    if (b.url += o({
      spec: t,
      scheme: a,
      contextUrl: s,
      server: c,
      serverVariables: f,
      pathName: _,
      method: w
    }), !r) return delete b.cookies, b;
    b.url += _, b.method = ("" + w).toUpperCase(), d = d || {};
    var O = t.paths[_] || {};
    n && (b.headers.accept = n);
    var q = W([].concat(J(k.parameters)).concat(J(O.parameters)));
    q.forEach(function (e) {
      var r = v[e.in],
          n = void 0;

      if ("body" === e.in && e.schema && e.schema.properties && (n = d), n = e && e.name && d[e.name], void 0 === n ? n = e && e.name && d[e.in + "." + e.name] : Q(e.name, q).length > 1 && console.warn("Parameter '" + e.name + "' is ambiguous because the defined spec has more than one parameter with the name: '" + e.name + "' and the passed-in parameter values did not define an 'in' value."), null !== n) {
        if (void 0 !== e.default && void 0 === n && (n = e.default), void 0 === n && e.required && !e.allowEmptyValue) throw new Error("Required parameter " + e.name + " is not provided");
        if (y && e.schema && "object" === e.schema.type && "string" == typeof n) try {
          n = JSON.parse(n);
        } catch (e) {
          throw new Error("Could not parse object parameter value string as JSON");
        }
        r && r({
          req: b,
          parameter: e,
          value: n,
          operation: k,
          spec: t
        });
      }
    });
    var M = (0, h.default)({}, e, {
      operation: k
    });

    if (b = y ? (0, H.default)(M, b) : (0, V.default)(M, b), b.cookies && (0, g.default)(b.cookies).length) {
      var A = (0, g.default)(b.cookies).reduce(function (e, t) {
        var r = b.cookies[t];
        return e + (e ? "&" : "") + E.default.serialize(t, r);
      }, "");
      b.headers.Cookie = A;
    }

    return b.cookies && delete b.cookies, (0, T.mergeInQueryOrForm)(b), b;
  }

  function o(e) {
    return (0, U.isOAS3)(e.spec) ? i(e) : c(e);
  }

  function i(e) {
    var t = e.spec,
        r = e.pathName,
        n = e.method,
        a = e.server,
        u = e.contextUrl,
        o = e.serverVariables,
        i = void 0 === o ? {} : o,
        c = (0, w.default)(t, ["paths", r, (n || "").toLowerCase(), "servers"]) || (0, w.default)(t, ["paths", r, "servers"]) || (0, w.default)(t, ["servers"]),
        f = "",
        p = null;

    if (a && c && c.length) {
      var d = c.map(function (e) {
        return e.url;
      });
      d.indexOf(a) > -1 && (f = a, p = c[d.indexOf(a)]);
    }

    if (!f && c && c.length && (f = c[0].url, p = c[0]), f.indexOf("{") > -1) {
      l(f).forEach(function (e) {
        if (p.variables && p.variables[e]) {
          var t = p.variables[e],
              r = i[e] || t.default,
              n = new RegExp("{" + e + "}", "g");
          f = f.replace(n, r);
        }
      });
    }

    return s(f, u);
  }

  function s() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        r = C.default.parse(e),
        n = C.default.parse(t),
        a = Y(r.protocol) || Y(n.protocol) || "",
        u = r.host || n.host,
        o = r.pathname || "",
        i = void 0;
    return i = a && u ? a + "://" + (u + o) : o, "/" === i[i.length - 1] ? i.slice(0, -1) : i;
  }

  function l(e) {
    for (var t = [], r = /{([^}]+)}/g, n = void 0; n = r.exec(e);) {
      t.push(n[1]);
    }

    return t;
  }

  function c(e) {
    var t = e.spec,
        r = e.scheme,
        n = e.contextUrl,
        a = void 0 === n ? "" : n,
        u = C.default.parse(a),
        o = Array.isArray(t.schemes) ? t.schemes[0] : null,
        i = r || o || Y(u.protocol) || "http",
        s = t.host || u.host || "",
        l = t.basePath || "",
        c = void 0;
    return c = i && s ? i + "://" + (s + l) : l, "/" === c[c.length - 1] ? c.slice(0, -1) : c;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.self = void 0;
  var f = r(8),
      p = n(f),
      d = r(3),
      h = n(d),
      v = r(52),
      y = n(v),
      m = r(0),
      g = n(m),
      b = r(2),
      x = n(b);
  t.execute = a, t.buildRequest = u, t.baseUrl = o;

  var P = r(6),
      k = (n(P), r(12)),
      w = n(k),
      _ = r(53),
      O = n(_),
      q = r(54),
      M = n(q),
      A = r(13),
      j = (n(A), r(10)),
      C = n(j),
      I = r(55),
      E = n(I),
      T = r(7),
      F = n(T),
      N = r(21),
      S = n(N),
      D = r(56),
      R = n(D),
      $ = r(57),
      z = n($),
      B = r(62),
      H = n(B),
      L = r(64),
      V = n(L),
      U = r(5),
      J = function J(e) {
    return Array.isArray(e) ? e : [];
  },
      G = (0, S.default)("OperationNotFoundError", function (e, t, r) {
    this.originalError = r, (0, x.default)(this, t || {});
  }),
      Q = function Q(e, t) {
    return t.filter(function (t) {
      return t.name === e;
    });
  },
      W = function W(e) {
    var t = {};
    e.forEach(function (e) {
      t[e.in] || (t[e.in] = {}), t[e.in][e.name] = e;
    });
    var r = [];
    return (0, g.default)(t).forEach(function (e) {
      (0, g.default)(t[e]).forEach(function (n) {
        r.push(t[e][n]);
      });
    }), r;
  },
      K = t.self = {
    buildRequest: u
  },
      Y = function Y(e) {
    return e ? e.replace(/\W/g, "") : null;
  };
}, function (e, t) {
  e.exports = require("babel-runtime/helpers/objectWithoutProperties");
}, function (e, t) {
  e.exports = require("lodash/isPlainObject");
}, function (e, t) {
  e.exports = require("lodash/isArray");
}, function (e, t) {
  e.exports = require("cookie");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    var t = e.req,
        r = e.value;
    t.body = r;
  }

  function a(e) {
    var t = e.req,
        r = e.value,
        n = e.parameter;
    (r || n.allowEmptyValue) && (t.form = t.form || {}, t.form[n.name] = {
      value: r,
      allowEmptyValue: n.allowEmptyValue,
      collectionFormat: n.collectionFormat
    });
  }

  function u(e) {
    var t = e.req,
        r = e.parameter,
        n = e.value;
    t.headers = t.headers || {}, void 0 !== n && (t.headers[r.name] = n);
  }

  function o(e) {
    var t = e.req,
        r = e.value,
        n = e.parameter;
    t.url = t.url.replace("{" + n.name + "}", encodeURIComponent(r));
  }

  function i(e) {
    var t = e.req,
        r = e.value,
        n = e.parameter;
    if (t.query = t.query || {}, !1 === r && "boolean" === n.type && (r = "false"), 0 === r && ["number", "integer"].indexOf(n.type) > -1 && (r = "0"), r) t.query[n.name] = {
      collectionFormat: n.collectionFormat,
      value: r
    };else if (n.allowEmptyValue && void 0 !== r) {
      var a = n.name;
      t.query[a] = t.query[a] || {}, t.query[a].allowEmptyValue = !0;
    }
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = {
    body: n,
    header: u,
    query: i,
    path: o,
    formData: a
  }, e.exports = t.default;
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e) {
    var t = e.req,
        r = e.value,
        n = e.parameter,
        a = n.name,
        u = n.style,
        o = n.explode,
        i = (0, d.default)({
      key: n.name,
      value: r,
      style: u || "simple",
      explode: o || !1,
      escape: !0
    });
    t.url = t.url.replace("{" + a + "}", i);
  }

  function u(e) {
    var t = e.req,
        r = e.value,
        n = e.parameter;

    if (t.query = t.query || {}, !1 === r && (r = "false"), 0 === r && (r = "0"), r) {
      var a = void 0 === r ? "undefined" : (0, f.default)(r);

      if ("deepObject" === n.style) {
        (0, l.default)(r).forEach(function (e) {
          var a = r[e];
          t.query[n.name + "[" + e + "]"] = {
            value: (0, d.default)({
              key: e,
              value: a,
              style: "deepObject",
              escape: n.allowReserved ? "unsafe" : "reserved"
            }),
            skipEncoding: !0
          };
        });
      } else if ("object" !== a || Array.isArray(r) || "form" !== n.style && n.style || !n.explode && void 0 !== n.explode) t.query[n.name] = {
        value: (0, d.default)({
          key: n.name,
          value: r,
          style: n.style || "form",
          explode: void 0 === n.explode || n.explode,
          escape: n.allowReserved ? "unsafe" : "reserved"
        }),
        skipEncoding: !0
      };else {
        var u = (0, l.default)(r);
        u.forEach(function (e) {
          var a = r[e];
          t.query[e] = {
            value: (0, d.default)({
              key: e,
              value: a,
              style: n.style || "form",
              escape: n.allowReserved ? "unsafe" : "reserved"
            }),
            skipEncoding: !0
          };
        });
      }
    } else if (n.allowEmptyValue && void 0 !== r) {
      var o = n.name;
      t.query[o] = t.query[o] || {}, t.query[o].allowEmptyValue = !0;
    }
  }

  function o(e) {
    var t = e.req,
        r = e.parameter,
        n = e.value;
    t.headers = t.headers || {}, h.indexOf(r.name.toLowerCase()) > -1 || void 0 !== n && (t.headers[r.name] = (0, d.default)({
      key: r.name,
      value: n,
      style: r.style || "simple",
      explode: void 0 !== r.explode && r.explode,
      escape: !1
    }));
  }

  function i(e) {
    var t = e.req,
        r = e.parameter,
        n = e.value;
    t.headers = t.headers || {};
    var a = void 0 === n ? "undefined" : (0, f.default)(n);

    if ("undefined" !== a) {
      var u = "object" === a && !Array.isArray(n) && r.explode ? "" : r.name + "=";
      t.headers.Cookie = u + (0, d.default)({
        key: r.name,
        value: n,
        escape: !1,
        style: r.style || "form",
        explode: void 0 !== r.explode && r.explode
      });
    }
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var s = r(0),
      l = n(s),
      c = r(1),
      f = n(c),
      p = r(58),
      d = n(p);
  t.default = {
    path: a,
    query: u,
    header: o,
    cookie: i
  };
  var h = ["accept", "authorization", "content-type"];
  e.exports = t.default;
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.escape,
        n = arguments[2];
    return "number" == typeof e && (e = e.toString()), "string" == typeof e && e.length && r ? n ? JSON.parse(e) : (0, v.stringToCharArray)(e).map(function (e) {
      return m(e) ? e : y(e) && "unsafe" === r ? e : ((0, h.default)(e) || []).map(function (e) {
        return ("0" + e.toString(16).toUpperCase()).slice(-2);
      }).map(function (e) {
        return "%" + e;
      }).join("");
    }).join("") : e;
  }

  function u(e) {
    var t = e.key,
        r = e.value,
        n = e.style,
        u = e.explode,
        o = e.escape,
        i = function i(e) {
      return a(e, {
        escape: o
      });
    };

    if ("simple" === n) return r.map(function (e) {
      return i(e);
    }).join(",");
    if ("label" === n) return "." + r.map(function (e) {
      return i(e);
    }).join(".");
    if ("matrix" === n) return r.map(function (e) {
      return i(e);
    }).reduce(function (e, r) {
      return !e || u ? (e || "") + ";" + t + "=" + r : e + "," + r;
    }, "");

    if ("form" === n) {
      var s = u ? "&" + t + "=" : ",";
      return r.map(function (e) {
        return i(e);
      }).join(s);
    }

    if ("spaceDelimited" === n) {
      var l = u ? t + "=" : "";
      return r.map(function (e) {
        return i(e);
      }).join(" " + l);
    }

    if ("pipeDelimited" === n) {
      var c = u ? t + "=" : "";
      return r.map(function (e) {
        return i(e);
      }).join("|" + c);
    }
  }

  function o(e) {
    var t = e.key,
        r = e.value,
        n = e.style,
        u = e.explode,
        o = e.escape,
        i = function i(e) {
      return a(e, {
        escape: o
      });
    },
        s = (0, l.default)(r);

    return "simple" === n ? s.reduce(function (e, t) {
      var n = i(r[t]),
          a = u ? "=" : ",";
      return (e ? e + "," : "") + t + a + n;
    }, "") : "label" === n ? s.reduce(function (e, t) {
      var n = i(r[t]),
          a = u ? "=" : ".";
      return (e ? e + "." : ".") + t + a + n;
    }, "") : "matrix" === n && u ? s.reduce(function (e, t) {
      var n = i(r[t]);
      return (e ? e + ";" : ";") + t + "=" + n;
    }, "") : "matrix" === n ? s.reduce(function (e, n) {
      var a = i(r[n]);
      return (e ? e + "," : ";" + t + "=") + n + "," + a;
    }, "") : "form" === n ? s.reduce(function (e, t) {
      var n = i(r[t]);
      return (e ? e + (u ? "&" : ",") : "") + t + (u ? "=" : ",") + n;
    }, "") : void 0;
  }

  function i(e) {
    var t = e.key,
        r = e.value,
        n = e.style,
        u = e.escape,
        o = function o(e) {
      return a(e, {
        escape: u
      });
    };

    return "simple" === n ? o(r) : "label" === n ? "." + o(r) : "matrix" === n ? ";" + t + "=" + o(r) : "form" === n ? o(r) : "deepObject" === n ? o(r) : void 0;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var s = r(0),
      l = n(s),
      c = r(1),
      f = n(c);
  t.encodeDisallowedCharacters = a, t.default = function (e) {
    var t = e.value;
    return Array.isArray(t) ? u(e) : "object" === (void 0 === t ? "undefined" : (0, f.default)(t)) ? o(e) : i(e);
  };

  var p = r(59),
      d = (n(p), r(60)),
      h = n(d),
      v = r(61),
      y = function y(e) {
    return ":/?#[]@!$&'()*+,;=".indexOf(e) > -1;
  },
      m = function m(e) {
    return /^[a-z0-9\-._~]+$/i.test(e);
  };
}, function (e, t) {
  e.exports = require("encode-3986");
}, function (e, t) {
  e.exports = require("utf8-bytes");
}, function (e, t) {
  e.exports = require("utfstring");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e) {
    var t = e.request,
        r = e.securities,
        n = void 0 === r ? {} : r,
        a = e.operation,
        u = void 0 === a ? {} : a,
        o = e.spec,
        i = (0, p.default)({}, t),
        s = n.authorized,
        l = void 0 === s ? {} : s,
        f = u.security || o.security || [],
        d = l && !!(0, c.default)(l).length,
        v = (0, h.default)(o, ["components", "securitySchemes"]) || {};
    return i.headers = i.headers || {}, i.query = i.query || {}, (0, c.default)(n).length && d && f && (!Array.isArray(u.security) || u.security.length) ? (f.forEach(function (e, t) {
      for (var r in e) {
        var n = l[r],
            a = v[r];

        if (n) {
          var u = n.value || n,
              o = a.type;
          if (n) if ("apiKey" === o) "query" === a.in && (i.query[a.name] = u), "header" === a.in && (i.headers[a.name] = u), "cookie" === a.in && (i.cookies[a.name] = u);else if ("http" === o) {
            if ("basic" === a.scheme) {
              var s = u.username,
                  c = u.password,
                  f = (0, y.default)(s + ":" + c);
              i.headers.Authorization = "Basic " + f;
            }

            "bearer" === a.scheme && (i.headers.Authorization = "Bearer " + u);
          } else if ("oauth2" === o) {
            var p = n.token || {},
                d = p.access_token,
                h = p.token_type;
            h && "bearer" !== h.toLowerCase() || (h = "Bearer"), i.headers.Authorization = h + " " + d;
          }
        }
      }
    }), i) : t;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u = r(8),
      o = n(u),
      i = r(1),
      s = n(i),
      l = r(0),
      c = n(l);
  t.default = function (e, t) {
    var r = e.operation,
        n = e.requestBody,
        u = e.securities,
        i = e.spec,
        l = e.attachContentTypeForEmptyPayload,
        f = e.requestContentType;
    t = a({
      request: t,
      securities: u,
      operation: r,
      spec: i
    });
    var p = r.requestBody || {},
        d = (0, c.default)(p.content || {}),
        h = f && d.indexOf(f) > -1;

    if (n || l) {
      if (f && h) t.headers["Content-Type"] = f;else if (!f) {
        var v = d[0];
        v && (t.headers["Content-Type"] = v, f = v);
      }
    } else f && h && (t.headers["Content-Type"] = f);

    return n && (f ? d.indexOf(f) > -1 && ("application/x-www-form-urlencoded" === f || 0 === f.indexOf("multipart/") ? "object" === (void 0 === n ? "undefined" : (0, s.default)(n)) ? (t.form = {}, (0, c.default)(n).forEach(function (e) {
      var r = n[e],
          a = void 0,
          u = void 0;
      "undefined" != typeof File && (u = r instanceof File), "undefined" != typeof Blob && (u = u || r instanceof Blob), void 0 !== m.Buffer && (u = u || m.Buffer.isBuffer(r)), a = "object" !== (void 0 === r ? "undefined" : (0, s.default)(r)) || u ? r : Array.isArray(r) ? r.toString() : (0, o.default)(r), t.form[e] = {
        value: a
      };
    })) : t.form = n : t.body = n) : t.body = n), t;
  }, t.applySecurities = a;
  var f = r(6),
      p = n(f),
      d = r(12),
      h = n(d),
      v = r(13),
      y = n(v),
      m = r(63);
}, function (e, t) {
  e.exports = require("buffer/");
}, function (e, t, r) {
  "use strict";

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function a(e) {
    var t = e.request,
        r = e.securities,
        n = void 0 === r ? {} : r,
        a = e.operation,
        u = void 0 === a ? {} : a,
        i = e.spec,
        l = (0, c.default)({}, t),
        f = n.authorized,
        p = void 0 === f ? {} : f,
        d = n.specSecurity,
        h = void 0 === d ? [] : d,
        v = u.security || h,
        y = p && !!(0, o.default)(p).length,
        m = i.securityDefinitions;
    return l.headers = l.headers || {}, l.query = l.query || {}, (0, o.default)(n).length && y && v && (!Array.isArray(u.security) || u.security.length) ? (v.forEach(function (e, t) {
      for (var r in e) {
        var n = p[r];

        if (n) {
          var a = n.token,
              u = n.value || n,
              o = m[r],
              i = o.type,
              c = o["x-tokenName"] || "access_token",
              f = a && a[c],
              d = a && a.token_type;
          if (n) if ("apiKey" === i) {
            var h = "query" === o.in ? "query" : "headers";
            l[h] = l[h] || {}, l[h][o.name] = u;
          } else "basic" === i ? u.header ? l.headers.authorization = u.header : (u.base64 = (0, s.default)(u.username + ":" + u.password), l.headers.authorization = "Basic " + u.base64) : "oauth2" === i && f && (d = d && "bearer" !== d.toLowerCase() ? d : "Bearer", l.headers.authorization = d + " " + f);
        }
      }
    }), l) : t;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u = r(0),
      o = n(u);
  t.default = function (e, t) {
    var r = e.spec,
        n = e.operation,
        u = e.securities,
        o = e.requestContentType,
        i = e.attachContentTypeForEmptyPayload;
    if (t = a({
      request: t,
      securities: u,
      operation: n,
      spec: r
    }), t.body || t.form || i) o ? t.headers["Content-Type"] = o : Array.isArray(n.consumes) ? t.headers["Content-Type"] = n.consumes[0] : Array.isArray(r.consumes) ? t.headers["Content-Type"] = r.consumes[0] : n.parameters && n.parameters.filter(function (e) {
      return "file" === e.type;
    }).length ? t.headers["Content-Type"] = "multipart/form-data" : n.parameters && n.parameters.filter(function (e) {
      return "formData" === e.in;
    }).length && (t.headers["Content-Type"] = "application/x-www-form-urlencoded");else if (o) {
      var s = n.parameters && n.parameters.filter(function (e) {
        return "body" === e.in;
      }).length > 0,
          l = n.parameters && n.parameters.filter(function (e) {
        return "formData" === e.in;
      }).length > 0;
      (s || l) && (t.headers["Content-Type"] = o);
    }
    return t;
  }, t.applySecurities = a;
  var i = r(13),
      s = n(i),
      l = r(6),
      c = n(l),
      f = r(7);
  n(f);
}]);